import { storage } from '../firebase.js';
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";

async function ImageUpload(img, imagePath) {
    if (img !== null) {
        const imgRef = ref(storage, imagePath);

        const uploadTask = uploadBytesResumable(imgRef, img);

        // Listen for state changes, errors, and completion of the upload.
        return new Promise((resolve, reject) => {
            uploadTask.on('state_changed',
                (snapshot) => {
                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log('Upload is ' + progress + '% done');
                    switch (snapshot.state) {
                        case 'paused':
                            console.log('Upload is paused');
                            break;
                        case 'running':
                            console.log('Upload is running');
                            break;
                    }
                },
                (error) => {
                    // A full list of error codes is available at
                    // https://firebase.google.com/docs/storage/web/handle-errors
                    switch (error.code) {
                        case 'storage/unauthorized':
                            // User doesn't have permission to access the object
                            console.log('User does not have permission to access the object');
                            reject(error);
                            break;
                        case 'storage/canceled':
                            // User canceled the upload
                            console.log('User canceled the upload');
                            reject(error);
                            break;

                        // ...

                        case 'storage/unknown':
                            // Unknown error occurred, inspect error.serverResponse
                            console.log('Unknown error occurred, inspect error.serverResponse');
                            reject(error);
                            break;
                    }
                },
                () => {
                    // Upload completed successfully, now we can get the download URL
                    getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                        console.log('File available at', downloadURL);
                        resolve(downloadURL); // Resolve the Promise with the download URL
                    });
                }
            );
        });

    }

    return null;

}
export default ImageUpload;